import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header/Header';
import MenuSection from '../components/MenuSection/MenuSection';
import { useTimeTracker } from '../hooks/useTimeTracker';
import { trackMenuTabChange } from '../utils/analytics';
import './MenuPage.css';

const MenuOnSitePage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('pizza');

  useTimeTracker('menu_onsite_page', true);

  return (
    <div className="menu-page">
      <Header />
      <div className="menu-header">
        <button className="back-button" onClick={() => navigate('/onSite')}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="back-icon"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="menu-title">{t('aquaFarina')}</h1>
      </div>

      <div className="menu-tabs">
        <button
          className={`tab-button ${activeTab === 'pizza' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('pizza');
            trackMenuTabChange('pizza');
          }}
        >
          {t('pizza')}
        </button>
        <button
          className={`tab-button ${activeTab === 'main' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('main');
            trackMenuTabChange('main');
          }}
        >
          {t('mainMenu')}
        </button>
      </div>

      <div className="menu-content">
        {activeTab === 'pizza' && <MenuSection menuType="pizza" />}
        {activeTab === 'main' && <MenuSection menuType="main" />}
      </div>

      <div className="menu-tabs menu-tabs-bottom">
        <button
          className={`tab-button ${activeTab === 'pizza' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('pizza');
            trackMenuTabChange('pizza');
          }}
        >
          {t('pizza')}
        </button>
        <button
          className={`tab-button ${activeTab === 'main' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('main');
            trackMenuTabChange('main');
          }}
        >
          {t('mainMenu')}
        </button>
      </div>
    </div>
  );
};

export default MenuOnSitePage;
